import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { DataService } from 'src/shared/data/data.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-contact-page',
    templateUrl: './contact-page.component.html',
    styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit {
    isLoading: boolean = false;

    constructor(
         private fb: FormBuilder,
         public data: DataService,
         private http: HttpClient,
         private meta: Meta,
         private titleService: Title
) {}

   ngOnInit(): void {
    this.contactForm = this.fb.group({
      lead_name: ['', Validators.required],
      contact_phone: [
  '',
  [
    Validators.required
  ]
],
      contact_email: ['', [
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
      ]],
      // customer_type: ['', Validators.required],
      delivery_location: ['', Validators.required],
      scope_of_project: [''],
      created_by: ['1'],
      source: ['10']
    });
 
    this.titleService.setTitle(
       'Contact Us – Kitchen Magic'
    );
 
    this.meta.updateTag({
      name: 'description',
      content: 'Contact Kitchen Magic for expert solutions. Get quotes, support, and professional assistance.'
    });
  }
        
              public contactForm!: FormGroup;
              url:string='';
    

    
projectsContent = [
        {
            subTitle: "Contact Us",
            title: "Contact Us – Kitchen Magic",
            paragraph: "Our expert culinary team is ready to assist you with delicious menu offerings, hygienic food preparation, timely service, and customized catering solutions for home gatherings, corporate events, and special occasions."
        }
    ];
    restrictToNumbers(event: any): void {
        const input = event.target as HTMLInputElement;
        input.value = input.value.replace(/[^0-9]/g, '');
    }

    preventNonNumeric(event: KeyboardEvent): void {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (allowedKeys.includes(event.key) || (event.ctrlKey && event.key === 'v')) {
            return;
        }
        if (!/^[0-9]$/.test(event.key)) {
            event.preventDefault();
        }
    }

//     addlead() {
// 		 this.isLoading = true;
//     if (this.contactForm.invalid) {
//         this.contactForm.markAllAsTouched();
//         this.isLoading = false;
//         return;
//     }

//     if (this.contactForm.valid) {
//         const leadData = this.contactForm.value;
//         const formData = new FormData();
//         Object.keys(leadData).forEach((key) => {
//             if(leadData[key] != '' && leadData[key] != undefined) {
//                 formData.append(key, leadData[key]);
//             }
//         });

//         this.http.post(this.url, formData).subscribe({
//             next: (response: any) => {
//                 this.contactForm.reset();
//                 this.isLoading = false; // Stop loading first
//                 alert('Thanks For Your Enquiry');
//                 // REMOVE: window.location.reload();
//             },
//             error: (error: any) => {
//                 this.isLoading = false;
//                 console.error('Error:', error);
//             }
//         });
//     }
//   } 


  submitContactForm() {

  this.isLoading = true;

  if (this.contactForm.invalid) {

    this.contactForm.markAllAsTouched();

    Swal.fire({
      icon: 'warning',
      title: 'Validation Error',
      text: 'Please fill all required fields correctly.'
    });

    this.isLoading = false;

    return;
  }

  this.http.post<any>(
    this.data.base_url +
    'save_contact_enquiry/',
    this.contactForm.value
  ).subscribe({

    next: (res) => {

      if (res.status === 1) {

        Swal.fire({
          icon: 'success',
          title: 'Thank You!',
          text:
            'Your enquiry has been submitted successfully.',
          confirmButtonColor: '#7c3aed'
        });

        this.contactForm.reset();

      } else {

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: res.message
        });

      }

    },

    error: (err) => {

      console.error(err);

      Swal.fire({
        icon: 'error',
        title: 'Server Error',
        text:
          'Something went wrong. Please try again later.'
      });

    },

    complete: () => {

      this.isLoading = false;

    }

  });

}
}